/* ----------------------------------------
    App generator
---------------------------------------- */

import StoreDispatcher from '@service/StoreDispatcher';

export default function * AppGenerator(vue: any) {
    yield StoreDispatcher.clearAppStore();
    yield StoreDispatcher.fetchApp();
}